import { Box, Flex, Text } from "@chakra-ui/react";
import React from "react";
import { FaGithub, FaLinkedin } from "react-icons/fa";
import { Link } from "react-router-dom";
import "../Css/Footer.css";

export const Footer = () => {
  return (
    <Flex
      gap="15px"
      boxSizing="border-box"
      alignItems={"center"}
      flexDirection={{
        base: "column",
        sm: "column",
        md: "column",
        lg: "row",
        xl: "row",
        "2xl": "row",
      }}
      color={"gray.300"}
      fontSize={"20px"}
      p={"10px"}
      justifyContent="space-between"
    >
      <Box
        fontWeight={"bold"}
        paddingLeft={"5px"}
        fontFamily={"Great Vibes"}
        className="footer-logo"
        fontSize={"25px"}
       
      >
        {"Ganesh"}
      </Box>
      <Box display={"flex"} alignItems={"center"}>
        <Text fontSize={"14px"} fontWeight={"700"}>
          Designed & Developed by <span className="creater">Ganesh Kumar</span>{" "}
        </Text>
      </Box>
      <Flex alignItems={"center"}>
        <Link id="contact-github" to="https://github.com/GaneshGourav">
          <FaGithub fontSize={"35px"} />
        </Link>
        <Link
          id="contact-linkedin"
          to="https://www.linkedin.com/in/ganeshofficial/"
        >
          <FaLinkedin
            style={{ marginLeft: "20px" }}
            color="#0e76a8"
            fontSize={"35px"}
          />
        </Link>
      </Flex>
    </Flex>
  );
};
